import { render, staticRenderFns } from "./edit-quotation.vue?vue&type=template&id=bab2159a&scoped=true"
import script from "./edit-quotation.vue?vue&type=script&lang=js"
export * from "./edit-quotation.vue?vue&type=script&lang=js"
import style0 from "./edit-quotation.vue?vue&type=style&index=0&id=bab2159a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab2159a",
  null
  
)

export default component.exports